import React from 'react';
import PropTypes from 'prop-types';

import { OKButton } from 'commonsComponents/OKButton';

const { withRouter } = require('react-router-dom');
import { ContentBox } from 'commonsComponents/contentBox';
import { IconWithDescriptionList } from 'components/commons/iconWithDescriptionList/iconWithDescriptionList';

import { recordLink, EVENT_ADD_ENTITY_WITHOUT_ENTITIES, PROC_ADD_ENTITY, PROC_GO_TO } from 'utilities/tagging';
const { FormattedText, formatText } = require('core/i18n').i18n;

class AggregatorResumeNoEntities extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    renderIconsSection(){
        const items = [{
            icon: 'icon-transparencia',
            text: formatText("aggregatorResume-itemSecureInfoDescription"),
            title: formatText("aggregatorResume-itemSecureInfoTitle")
        },{
            icon: 'icon-estrategia',
            text: formatText("aggregatorResume-itemMakesEstimationsDescription"),
            title: formatText("aggregatorResume-itemMakesEstimationsTitle")
        },{
            icon: 'icon-ahorra-dinero',
            text: formatText("aggregatorResume-itemControlExpensasDescription"),
            title: formatText("aggregatorResume-itemControlExpensasTitle")
        },{
            icon: 'icon-simplificar',
            text: formatText("aggregatorResume-itemCheckMovementsDescription"),
            title: formatText("aggregatorResume-itemCheckMovementsTitle")
        }]

        return (
            <div className="aggregator-resume-section__content__no-entities__icons-section">
                <IconWithDescriptionList
                    align={'center'}
                    iconsWithBackground={true}
                    items={items}
                />
            </div>
        )
    }

    handleOnClick = () => {
        recordLink(PROC_ADD_ENTITY, PROC_GO_TO, EVENT_ADD_ENTITY_WITHOUT_ENTITIES)

        this.props.history.push("/myprofile/global/entities/add")
    }

    renderButtonsSection = () => {
        return (
            <div className="aggregator-resume-section__content__no-entities__buttons-section row">
                <div data-gtns-component-name="agregador" className="aggregator-resume-section__content__no-entities__buttons-section__right col-xs-12">
                    <OKButton onClick={() => this.handleOnClick()}>
                        <FormattedText value="aggregatorResume-buttonAddEntity" />
                    </OKButton>
                </div>
            </div>
        )
    }

    render = () => {
        return (
            <div id="pg-other-banks" className="aggregator-resume-section__content__no-entities">
                <div className="aggregator-resume-section__header row">
                    <h3 className="aggregator-resume-section__header-title col-xs-12">
                        <FormattedText value="aggregatorResume-title" />
                    </h3>
                </div>
                <ContentBox>
                    <div className="aggregator-resume-section__content__no-entities__text-section">
                        <h3 className="aggregator-resume-section__content__no-entities__text-section__title">
                            {formatText("aggregatorResume-textSectionTitle")}
                        </h3>
                        <p className="aggregator-resume-section__content__no-entities__text-section__text">
                            <FormattedText value="aggregatorResume-textSectionText" />
                        </p>
                    </div>
                    {this.renderIconsSection()}
                    {this.renderButtonsSection()}
                </ContentBox>
            </div>
        );
    }
}

AggregatorResumeNoEntities.propTypes = {
    aggregationData: PropTypes.object,
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorResumeNoEntities)
